import React from 'react';

export interface BikeIconProps {}

export const BikeIcon: React.FC<BikeIconProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.138 10.287l-.953.318A.9.9 0 0 1 6 9.751v-.597c0-.401.042-.547.12-.694a.818.818 0 0 1 .34-.34c.147-.078.293-.12.694-.12H9.75a.75.75 0 0 1 .75.75v.007c0 .173-.025.319-.075.445a.807.807 0 0 1-.231.32 1.182 1.182 0 0 1-.399.213l-.205.068 2.277 3.961 3.318-5.53-.58-1.451a.45.45 0 0 0-.417-.283H12.75a.75.75 0 0 1 0-1.5h1.438a1.95 1.95 0 0 1 1.81 1.226l2.513 6.282a3.75 3.75 0 1 1-1.457.397l-1.169-2.923-3.083 5.14a1.79 1.79 0 0 1 .398 1.128 1.798 1.798 0 0 1-2.194 1.753L5.688 16.8a.563.563 0 0 1 0-1.098l4.92-1.115-2.471-4.299zm.233 3.884l-1.653.374a2.25 2.25 0 1 0 0 3.41l1.653.374a3.75 3.75 0 1 1 0-4.159zM21 16.25a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0z"
        fill="currentColor"
      ></path>
    </svg>
  );
};
